import React from 'react'
import { Row, Col } from "antd";
import "./css/payment.css";
import dayjs from "dayjs";
import THBText from "thai-baht-text";
import imgA2 from "./pic/a2.jpg"

function NotifyGuarantor3N({ dataTabelB, selectedContract, indexA, indexB, roundDate }) {
  //โหลดรูป
  const nameCus1 = dataTabelB?.SNAM + "" + dataTabelB?.NAME1 + " " + dataTabelB?.NAME2;
  // const nameCus0 = dataTabelB?.BSNAM + "" + dataTabelB?.BNAME1 + " " + dataTabelB?.BNAME2;
  const datePrint = dayjs().format("DD/MM/YYYY");
  const dateSDATE = dayjs(dataTabelB?.SDATE).format("DD/MM/YYYY");
  const dateDDATE = dayjs(dataTabelB?.FirstUnpaidDate).format("DD/MM/YYYY");
  const dateRoundDate = dayjs(roundDate).format("DD/MM/YYYY");
  const CONTNO = dataTabelB?.CONTNO

  let addCompany1, T1, A1, J1;
  J1 = `จ. ${dataTabelB?.PROVDES}`;
  if (selectedContract?.key === "vsfhp") {
    addCompany1 = "บริษัท วัน ลิสซิ่ง จำกัด";
  } else {
    addCompany1 = "บริษัท วัน มันนี่ จำกัด";
  }
  if (dataTabelB?.PROVCOD === "01") {
    T1 = `แขวง ${dataTabelB?.TUMB}`;
    A1 = `เขต ${dataTabelB?.AUMPDES}`;
  } else {
    T1 = `ต.${dataTabelB?.TUMB}`;
    A1 = `อ.${dataTabelB?.AUMPDES}`;
  }

  return (
    <>
      <div className="divA4">
        <div className="divEdge30">
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>{indexA + 1}/{indexB}</Col>
            {/* <Col span={24} style={{ marginBottom: '40px' }}></Col> */}
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">ชื่อลูกค้า :&emsp;&nbsp;&nbsp;{nameCus1} (คนค้ำ{dataTabelB?.GARNO}) ({CONTNO})</Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">ที่อยู่ :&emsp;&emsp;&nbsp;&nbsp;&nbsp;เลขที่&nbsp;{dataTabelB?.ADDR1}{dataTabelB?.ADDR2}</Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">&emsp;&emsp;&emsp;&emsp;{T1}&nbsp;{A1}&nbsp;{J1}&nbsp;{dataTabelB?.ZIP}</Col>
            <Col span={2} className="colLeft0"></Col>
            <Col span={22} className="colLeft0">เบอร์โทร :&emsp;&nbsp;{dataTabelB?.TELP}</Col>
            <Col span={4} className="colLeft0"></Col>
            <Col span={20} className="colLeft0">&emsp;({dateRoundDate})</Col>

            <Col span={24} style={{ marginBottom: '130px' }}></Col>
            <Col span={24} className="colRight" />


            <Col span={16} className="colLeft"></Col>
            <Col span={8} className="colLeft">วันที่ :&emsp;{datePrint}</Col>
            <Col span={24} style={{ marginBottom: '10px' }}></Col>
            <Col span={24} className="colLeft">เรื่อง&emsp;แจ้งให้ชำระหนี้ที่ค้างชำระ สัญญากู้ยืมเงินเลขที่({dataTabelB?.CONTNO})</Col>
            <Col span={24} className="colLeft">เรียน&emsp;{nameCus1}</Col>

            <Col span={24} style={{ marginBottom: '20px' }}></Col>
            <Col span={24} className="colLeft">&emsp;ตามที่ท่านผู้กู้ได้ตกลงทำสัญญากู้ยืมเงินจำนวน {
                Number(dataTabelB?.TCARCST ?? 0).toLocaleString('th-TH', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })} บาท
               ({THBText(dataTabelB?.TCARCST)}) ไปจาก{addCompany1}</Col>
            <Col span={24} className="colLeft">(สำนักงานใหญ่) ตามสัญญากู้ยืมเงิน ลงวันที่ {dateSDATE} โดยผู้กู้ได้รับ เงินไปครบถ้วนแล้วและได้มอบสมุดคู่มือจดทะเบียนรถยนต์ยี่ห้อ</Col>
             
            <Col span={3} className="colLeft">{dataTabelB?.TYPE}</Col>
            <Col span={1} className="colLeft">รุ่น</Col>
            <Col span={4} className="colLeft">{dataTabelB?.MODEL}</Col>
            <Col span={2} className="colLeft">เลขตัวถัง</Col>
            <Col span={5} className="colLeft">{dataTabelB?.STRNO}</Col>
            <Col span={2} className="colLeft">เลขเครื่อง</Col>
            <Col span={5} className="colLeft">{dataTabelB?.ENGNO}</Col>
            <Col span={2} className="colLeft">ทะเบียน</Col>

            <Col span={4} className="colLeft">{dataTabelB?.REGNO}&nbsp;{dataTabelB?.DORECV}</Col>
            <Col span={1} className="colLeft">สี</Col>
            <Col span={4} className="colLeft">{dataTabelB?.COLOR}</Col>
            <Col span={15} className="colLeft">มามอบให้ผู้ให้กู้ เพื่อยึดถือไว้เป็นประกันหนี้ตามสัญญากู้ยืมเงิน และท่านได้ทำสัญญา</Col>
            <Col span={24} className="colLeft">ค้ำประกันหนี้ดังกล่าว รายละเอียดท่านทราบแจ้งชัดดีอยู่แล้วนั้น</Col> 

            <Col span={9} className="colLeft">&emsp;บัดนี้ ผู้กู้ได้ผิดนัดและค้างชำระหนี้ค่างวดที่ </Col> 
            <Col span={2} className="colLeft">{dataTabelB?.EXP_FRM}-{dataTabelB?.EXP_TO}</Col> 
            <Col span={3} className="colLeft">ซึ่งกำหนดชำระ </Col>
            <Col span={10} className="colLeft">{dateDDATE} จำนวน {dataTabelB?.EXP_PRD} งวดติดต่อกันเป็นเงินจำนวน</Col>
   
            <Col span={4} className="colLeft">
              {
                Number(dataTabelB?.EXP_AMT ?? 0).toLocaleString('th-TH', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }  บาท
            </Col>
            <Col span={8} className="colLeft">({THBText(dataTabelB?.EXP_AMT)})</Col>
            <Col span={12} className="colLeft">ผู้ให้กู้จึงแจ้งมายังท่านเพื่อให้ชำระหนี้ที่ผู้กู้ค้างชำระ พร้อมดอกเบี้ย</Col>

            <Col span={24} className="colLeft">เบี้ยปรับ และค่าใช้จ่ายทั้งหมดให้แล้วเสร็จภายใน 7 วัน นับแต่วันที่ท่านได้รับหนังสือฉบับนี้</Col>
  
            <Col span={24} style={{ marginBottom: '20px' }}></Col>
            <Col span={24} className="colLeft">&emsp;หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้กู้มีความจำเป็นที่จะต้อง ดำเนินการตามกฎหมายต่อไป</Col>
            <Col span={24} className="colLeft">&emsp;&emsp;จึงเรียนมาเพื่อโปรดดำเนินการด่วน</Col>

            <Col span={24} style={{ marginBottom: '60px' }}></Col>
            <Col span={18} className="colCenter00"></Col>
            <Col span={6} className="colCenter00"><img src={imgA2} alt="example" style={{ height: '36px' }} /></Col>
            <Col span={18} className="colLeft"></Col>
            <Col span={6} className="colCenter">ลงชื่อ.................................</Col>

            <Col span={24} style={{ marginBottom: '40px' }}></Col>
            <Col span={18} className="colLeft"></Col>
            <Col span={6} className="colCenter">ผู้ออกจดหมาย</Col>

            <Col span={24} style={{ marginBottom: '40px' }}></Col>
            <Col span={24} className="colLeft">- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย</Col>
          </Row>
        </div>
      </div>
    </>
  );
}
export default NotifyGuarantor3N;
